/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, mp */

_.namespace(`Backbone.widgets`, function() {
  'use strict';

  var ModalWindow = Backbone.Widget.extend({
    className: `backbone_modal_window`,
    templates: {
      "base":
                `<div class="window_wrap <%= d.window_wrap_class %>">` +
                    `<div class="close"><svg-icon icon="x"></svg-icon></div>` +
                    `<div class="window">` +
                        `<div class="content"></div>` +
                    `</div>` +
                `</div>`,
    },

    events: {
      'click .close': `handle_close`,
      'click': `clickout`,
    },

    initialize() {
      this.render();
    },

    render() {
      this.render_base_template(_.defaults(this.options, {
        window_wrap_class: ``,
        top_offset: 0,
        theme: `default`, // or 'moderndark'
      }));
      this.hide();
      this.$el.addClass(this.options.theme + `_theme`);
      this.$el.appendTo(this.options.wrapper || `body`);

      this.content = this.$(`.content`);

      if (_.isNumber(this.options.padding)) {
        this.$(`.window`).css(`padding`, this.options.padding);
      } else {
        this.options.padding = 14;
      }
      if (this.options.wrapper) {
        this.$el.css(`position`, `absolute`);
      }

      var width_prop, width_px;
      if (this.options.width) { width_prop = `width`; width_px = this.options.width; }
      else if (this.options.min_width) { width_prop = `min-width`; width_px = this.options.min_width; }
      else if (this.options.max_width) { width_prop = `max-width`; width_px = this.options.max_width; }

      if (width_prop) {
        this.$(`.window_wrap`).css(width_prop, width_px + (this.options.padding * 2));
      }

      if (this.options.widget) {
        this.set_widget(this.options.widget);
      }

      if (this.options.disable_close || this.options.hide_close) {
        this.$el.addClass(`close_disabled`);
        this.$(`.close`).hide();
      }

      this.on_close(function() {
        if (this.widget) { this.widget.close(); }
        $(this.options.wrapper || window).off(`resize.backbone_modal_widget`);
      });
    },

    set_widget(widget) {
      if (this.widget) { this.widget.close(); }
      this.widget = widget;

      this.content.empty().append(this.widget.el);
    },

    set_content(el) {
      this.content.empty().append(el);
    },

    show() {
      this.$el.show();
      this.content.children().show();
      $(this.options.wrapper || window).on(`resize.backbone_model_widget`, _.bind(this.resize, this)).resize();
      this.trigger(`show`);
      mp.utility.bind_esc(this.cid, this.handle_close, this);
      return this;
    },

    hide() {
      this.$el.hide();
      $(this.options.wrapper || window).off(`resize.backbone_modal_widget`);
      this.trigger(`hide`);
      mp.utility.unbind_esc(this.cid);
      return this;
    },

    is_visible() {
      return this.$el.is(`:visible`);
    },

    handle_close() {
      if (!this.options.disable_close) {
        this.hide();
        if (this.options.on_close) {
          this.options.on_close.apply(window, arguments);
        }
      }
    },

    clickout(ev) {
      if (ev.target === this.el && !this.options.prevent_clickout) {
        this.handle_close();
      }
    },

    resize() {
      var w_width = $(this.options.wrapper || window).width(),
        w_height = $(this.options.wrapper || window).height(),
        modal_window = this.$(`.window_wrap`),
        e_width = modal_window.outerWidth(),
        e_height = modal_window.outerHeight(),
        left = Math.round((w_width / 2) - (e_width / 2)),
        top = Math.round(this.options.top || (w_height / 2) - (e_height / 2));
      if (this.options.top_offset && (this.options.top_offset + top) > 0) {
        top += this.options.top_offset;
      }

      if (top < 0) {
        top = 0;
      }

      modal_window.css({
        top,
        left,
      });
    },
  });

  return {
    ModalWindow,
  };
});

}.call(window));